export function hasCustomTimeFeatureFor(features: string[], admin?: boolean) {
  return features.includes('custom_time') || Boolean(admin);
}

export default hasCustomTimeFeatureFor;
